import React, { useState, useEffect } from "react";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { toast } from "react-toastify";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";


function PartnerSignupMenu(props) {
    const { fetchRequest } = useMyContext()
    const baseURL = process.env.REACT_APP_Baseurl
    const updateApi = `${baseURL}/admin/partner-signup-menu-store`
    const createApi = `${baseURL}/admin/partner-signup-menu`

    const [loading, setLoading] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [showOverlay, setShowOverlay] = useState(false);


    const [editUser, setEditUser] = useState({
        id: "",
        user_id: "",
        username: "",
        email: "",
        gender: "",
        mobile: "",
        best_content: "",
        avatar: "",
        password: "",
        password_confirm: "",
        city: "",
        state: "",
        country: ""
    });

    useEffect(async () => {
        setLoading(true)
        await fetchRequest({
            method: 'GET',
            url: `${createApi}`,
            params: {},
            data: {},
        })
            .then((response) => {
                setEditUser(response?.signup_menu)
            }).catch((error) => {
                toast.error(error?.response?.data?.message || "Something went wrong ")
            }).finally(() => {
                setLoading(false)
            })
    }, [])

    const handleUpdate = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in editUser) {
                formDataAdd[key] = editUser[key]
            }
            const response = await fetchRequest({
                method: 'POST',
                url: `${updateApi}`,
                params: {},
                data: formDataAdd,
            })
            const result = response;
            if (result?.status) {
                toast.success(result?.message)
                setWithOutRefresh(!withOutRefresh)
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setShowOverlay(false)
        }
    }


    const handleInput = (e) => {
        const { name, type, value, checked } = e.target;
        if (type === 'checkbox') {
            const avoidUpdate = ["username", "email", "gender","mobile", "password", "password_confirm","avatar","best_content"]
            if (avoidUpdate.includes(name)) return
            setEditUser((prevEditUser) => ({
                ...prevEditUser,
                [name]: checked ? 1 : 0,
            }));
        }
    }

    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />
    }

    return (
        <>
            {showOverlay && (<Response_Processing />)}
            <AdminSaveHeader heading={"Partner-Signup Menu"} saveText={"Submit"} saveMethod={handleUpdate} loading={showOverlay} />

            <div className="p-3 theme-bg-color rounded-3">
                <table className="w-100 ">
                    <thead className="theme-border-bottom-text-bold">
                        <tr>
                            <th className="py-2"><MessageLabel text="S.No" noMargin /> </th>
                            <th className="py-2"><MessageLabel text="Name" noMargin /> </th>
                            <th className="py-2"> <MessageLabel text="Status" noMargin /></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="theme-border-bottom-text">
                            <td className="py-3 "><MessageBox text="1" noMargin /></td>
                            <td className="py-3 "> <MessageBox text="Profile Name" noMargin /></td>
                            <td className="py-3 "><AdminSwitch name={'username'} checked={editUser?.username == 1} onChange={handleInput} /></td>
                        </tr>
                        <tr className="theme-border-bottom-text">
                            <td className="py-3 "><MessageBox text="2" noMargin /></td>
                            <td className="py-3 "> <MessageBox text="Profile Email" noMargin /></td>
                            <td className="py-3 "><AdminSwitch name={'email'} checked={editUser?.email == 1} onChange={handleInput} /></td>
                        </tr>
                        <tr className="theme-border-bottom-text">
                            <td className="py-3 "><MessageBox text="3" noMargin /></td>
                            <td className="py-3 "> <MessageBox text="Profile Gender" noMargin /></td>
                            <td className="py-3 "><AdminSwitch name={'gender'} checked={editUser?.gender == 1} onChange={handleInput} /></td>
                        </tr>

                        <tr className="theme-border-bottom-text">
                            <td className="py-3 "><MessageBox text="4" noMargin /></td>
                            <td className="py-3 "> <MessageBox text="Profile Mobile Number" noMargin /></td>
                            <td className="py-3 "><AdminSwitch name={'mobile'} checked={editUser?.mobile == 1} onChange={handleInput} /></td>
                        </tr>

                        <tr className="theme-border-bottom-text">
                            <td className="py-3 "><MessageBox text="5" noMargin /></td>
                            <td className="py-3 "> <MessageBox text="Profile Image" noMargin /></td>
                            <td className="py-3 "><AdminSwitch name={'avatar'} checked={editUser?.avatar == 1} onChange={handleInput} /></td>
                        </tr>

                        <tr className="theme-border-bottom-text">
                            <td className="py-3 "><MessageBox text="6" noMargin /></td>
                            <td className="py-3 "> <MessageBox text="Profile Best Content" noMargin /></td>
                            <td className="py-3 "><AdminSwitch name={'best_content'} checked={editUser?.best_content == 1} onChange={handleInput} /></td>
                        </tr>
                        <tr className="theme-border-bottom-text">
                            <td className="py-3 "><MessageBox text="7" noMargin /></td>
                            <td className="py-3 "> <MessageBox text="Profile Password" noMargin /></td>
                            <td className="py-3 "><AdminSwitch name={'password'} checked={editUser?.password == 1} onChange={handleInput} /></td>
                        </tr>

                        <tr className="theme-border-bottom-text">
                            <td className="py-3 "><MessageBox text="8" noMargin /></td>
                            <td className="py-3 "> <MessageBox text="Profile Password Confirm" noMargin /></td>
                            <td className="py-3 "><AdminSwitch name={'password_confirm'} checked={editUser?.password_confirm == 1} onChange={handleInput} /></td>
                        </tr>
                        <tr className="theme-border-bottom-text">
                            <td className="py-3 "><MessageBox text="9" noMargin /></td>
                            <td className="py-3 "> <MessageBox text="Profile Country" noMargin /></td>
                            <td className="py-3 "><AdminSwitch name={'country'} checked={editUser?.country == 1} onChange={handleInput} /></td>
                        </tr>
                        <tr className="theme-border-bottom-text">
                            <td className="py-3 "><MessageBox text="10" noMargin /></td>
                            <td className="py-3 "> <MessageBox text="Profile State" noMargin /></td>
                            <td className="py-3 "><AdminSwitch name={'state'} checked={editUser?.state == 1} onChange={handleInput} /></td>
                        </tr>

                        <tr className="theme-border-bottom-text">
                            <td className="py-3 "><MessageBox text="11" noMargin /></td>
                            <td className="py-3 "> <MessageBox text="Profile City" noMargin /></td>
                            <td className="py-3 "><AdminSwitch name={'city'} checked={editUser?.city == 1} onChange={handleInput} /></td>
                        </tr>
                    </tbody>
                </table>
            </div>


        </>
    );
}

export default PartnerSignupMenu;